angular.module('tf.services')

    .service('Session',['User','$q', 'WebSocketService','$rootScope','AUTH_EVENTS','HttpService','SessionStorageService', function (User, $q, WebSocketService,$rootScope, AUTH_EVENTS,HttpService,SessionStorageService) {

        this.ready = $q.defer();
        this.whenReady = function(){
            return this.ready.promise;
        };
        this.create = function (user) {
            if(!angular.equals({}, user)){

                this.user = new User(user);
                this.farm = this.user.getFarm().farm;
                this.role = this.user.getFarm().role;
                $rootScope.farmId = this.farm._id;
                SessionStorageService.setItem('userRole', this.role);
                // this.ready.resolve(this);
                var self = this;
                WebSocketService.createWS().then(function(){
                    // WebSocketService.subscribeFarmPublic(self.farm._id);
                    // HttpService.get('user/me/assets').then(function(res){
                    //     self.user.assets = res.data;
                    //     var fids = _.uniq(_.map(self.user.assets,'farmer'));
                    //     for (var i = 0; i < fids.length; i++) {
                    //         var fid = fids[i];
                    //         WebSocketService.subscribePublic(fid);
                    //     }
                    //     self.ready.resolve(this);
                    // });


                });

                $rootScope.$on(AUTH_EVENTS.sessionTimeout, function(){
                    self.destroy();
                });
                $rootScope.$on("ws-open", function(){
                    WebSocketService.subscribeFarmPublic(self.farm._id);
                    HttpService.get('user/me/assets').then(function(res){
                        self.user.assets = res.data.assets;

                        res.data.farmers.forEach(function(farmer){
                            WebSocketService.subscribePublic(farmer);
                        });

                        self.ready.resolve(this);
                    });
                });

                $rootScope.$on('farmSettings', function(e, settings){
                    Object.assign(self.farm.settings, settings);
                    $rootScope.$broadcast('initTasks');
                });
            }
        };


        this.destroy = function () {
            this.user = null;
            this.farm = null;
            this.role = null;
            SessionStorageService.removeItem('userRole');
        };


        this.setEmail = function(email){
            this.email = email;
        };
        this.getEmail = function(){
            if(this.email){
                var email = this.email;
                this.email = null;
                return email;
            }
            return null;
        };
        this.loadUser = function(){
            var defer = $q.defer();
            HttpService.get('user/me').then(function(res){
                defer.resolve(res.data);
            });
            return defer.promise;
        };
        this.updateUser = function(user){
            this.user = angular.extend(this.user, user);
        };
        this.updateFarm = function(farm){
            this.farm = angular.extend(this.farm, farm);
        };
        this.getFarm = function(){
           return this.farm;
        };
        this.isFarmOwner = function () {
            return this.farm && this.user && this.farm.owner === this.user.id;
        };

        return this;
    }])
;
